export const status = {
  active: 'Active',
  inactive: 'Inactive'
}
